import { IDistrictsContext } from "./DistrictsProviderTypes"

export const DISTRICTS_INITIAL_CONTEXT: IDistrictsContext = {
  districts: {
    data: [],
    itemCount: 0,
    skip: 0,
    take: 10,
  },
  addDistrict: () => {},
  addDistrictLoading: false,
  updateDistrict: () => {},
  updateDistrictLoading: false,
  deleteDistrict: () => {},
  deleteDistrictLoading: false,
  currentDistrict: null,
  setCurrentDistrict: () => {},
  handlePageChagne: () => {},
  currentPage: 1,
}
